export const COLOR = {
  primary: '#f55737',
  black: 'black',
  error: '#D94C4C',
} as const;

export const FONT_SIZE = {
  small: '14px',
} as const;
